import styled from 'styled-components';
import React from 'react';
import GridColumns from 'pages/ebooks/components/templates/GridColumns';
import { fetchStorageFile } from 'hooks/StoreFiles';
import StyledGlobal from '../../PlanoAnual2025.styled';
import ResponsiveGrid from 'pages/ebooks/components/templates/ResponsiveGrid';
import { IsCustomMaxWidth } from 'core/util/WindowSize';

const Styled = {
    Container: styled.div`
        display: flex;
        flex-direction: column;
        background-color: #eae8e6;
        font-family: 'Barlow', sans-serif;
        padding-bottom: 80px;
        padding-top: 80px;
    `,

    Content: styled.div`
        display: flex;
        flex-direction: column;
        gap: 1rem;
    `,
};

interface ItemSumaryProps {
    listRefs: React.RefObject<HTMLDivElement>[];
    onClickItem: (ref: React.RefObject<HTMLDivElement>, index: number) => void;
}

const ItemSumary = (props: { title: string; blue?: boolean; onClick?: () => void }) => {
    const isWith500Max = IsCustomMaxWidth(500);

    return (
        <div style={{ marginTop: '20px', cursor: 'pointer' }} onClick={props.onClick}>
            <h1
                style={{
                    textTransform: 'uppercase',
                    fontSize: isWith500Max ? '1rem' : '1.5rem',
                    fontWeight: 'bold',
                    color: props.blue ? '#0e60e8' : 'black',
                }}
            >
                {props.title}
            </h1>
        </div>
    );
};

const SumaryPlanoAnual: React.FC<ItemSumaryProps> = ({ listRefs, onClickItem }) => {
    return (
        <Styled.Container>
            <ResponsiveGrid
                templates={{
                    desktop: '1fr 1fr',
                    notebook: '1fr 1fr',
                    tablet: '1fr',
                }}
            >
                <Styled.Content>
                    <img
                        width={'100%'}
                        height={'500px'}
                        style={{ objectFit: 'cover', borderRadius: '20px' }}
                        src={fetchStorageFile('anexo_storage_files_15834300182835390569.webp_2025-11-18-1763499371420.webp')}
                        alt=""
                    />
                </Styled.Content>
                <Styled.Content style={{ alignItems: 'center' }}>
                    <div>
                        <StyledGlobal.Title blue>SUMÁRIO</StyledGlobal.Title>
                        <ItemSumary blue title="1. APRESENTAÇÃO GERAL DO PLANO ANUAL ...5" onClick={() => onClickItem(listRefs[0], 4)} />
                        <ItemSumary
                            blue
                            title="2. ABRANGÊNCIA DO PLANO .............................9"
                            onClick={() => onClickItem(listRefs[1], 5)}
                        />
                        <ItemSumary
                            blue
                            title="3. ANÁLISE DOS MUNICÍPIOS .............................11"
                            onClick={() => onClickItem(listRefs[2], 6)}
                        />
                        <div style={{ marginLeft: '30px' }}>
                            <ItemSumary title="3.1 JABOATÃO DOS GUARARAPES ................12" onClick={() => onClickItem(listRefs[3], 7)} />
                            <ItemSumary
                                title="3.2 MACAÉ .....................................................21"
                                onClick={() => onClickItem(listRefs[4], 8)}
                            />
                            <ItemSumary
                                title="3.3 MACEIÓ ....................................................31"
                                onClick={() => onClickItem(listRefs[5], 9)}
                            />
                            <ItemSumary
                                title="3.4 NATAL .....................................................41"
                                onClick={() => onClickItem(listRefs[6], 10)}
                            />
                            <ItemSumary
                                title="3.5 NOVA IGUAÇU ..........................................51"
                                onClick={() => onClickItem(listRefs[7], 11)}
                            />
                            <ItemSumary
                                title="3.6 SÃO LUÍS .................................................61"
                                onClick={() => onClickItem(listRefs[8], 12)}
                            />
                        </div>
                    </div>
                </Styled.Content>
            </ResponsiveGrid>
        </Styled.Container>
    );
};

export default SumaryPlanoAnual;
